import WYSIWYG from '@components/ui/WYSIWYG'
import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'
interface Props {
  slice: any
}
interface Image {
  alt: string
  dimensions: {
    width: number
    height: number
  }
  url: string
}
interface Stockist {
  name: string
  location: string
  description: []
  addressLine1: string
  addressLine2: string
  links: string
  badges: string
  image: Image
  kspIcon1: Image
  kspIcon2: Image
  kspIcon3: Image
  kspIcon4: Image
  kspIcon5: Image
  kspIcon6: Image
  kspText1: string
  kspText2: string
  kspText3: string
  kspText4: string
  kspText5: string
  kspText6: string
  link_field: any
}
const Stockists = ({ slice }: Props) => {
  const { items } = slice
  const { primary } = slice
  const title = primary?.title
  return (
    <div>
      {title && (
        <div className="heading-mobile-3 lg:heading-3 pb-6 text-brand-dark-grey lg:pb-10">
          {title}
        </div>
      )}
      <div className="stockistContainer">
        {items?.map((stockist: Stockist, index: number) => {
          const imageUrl = stockist?.image?.url
          const imageAlt = stockist?.image?.alt
          const badges = stockist?.badges?.split(',')
          const name = stockist?.name
          const location = stockist?.location
          const description = stockist?.description
          const addressLine1 = stockist?.addressLine1
          const addressLine2 = stockist?.addressLine2
          const links = stockist?.links?.split(',')
          const kspIcon1 = stockist?.kspIcon1
          const kspIcon2 = stockist?.kspIcon2
          const kspIcon3 = stockist?.kspIcon3
          const kspIcon4 = stockist?.kspIcon4
          const kspIcon5 = stockist?.kspIcon5
          const kspIcon6 = stockist?.kspIcon6
          const kspText1 = stockist?.kspText1
          const kspText2 = stockist?.kspText2
          const kspText3 = stockist?.kspText3
          const kspText4 = stockist?.kspText4
          const kspText5 = stockist?.kspText5
          const kspText6 = stockist?.kspText6
          const linkField = stockist?.link_field
          return (
            <div key={index} className="stockist">
              <div className="flex flex-col">
                {imageUrl && (
                  <div className="stockistImage relative pb-3">
                    <Image
                      alt={imageAlt || config.openGraph.images[0].alt}
                      src={imageUrl}
                      width={304}
                      height={406}
                    />
                    {badges && (
                      <div className="absolute right-2 top-2 flex flex-col items-end gap-1">
                        {badges?.map((badge: any, index: number) => {
                          return (
                            <div
                              className="rounded-2xl bg-brand-dark-grey px-2 font-roboto text-body3 font-medium uppercase text-brand-light-grey"
                              key={index}
                            >
                              {badge}
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                )}
                {name && (
                  <div className="heading-mobile-4 lg:heading-4 pb-3 text-brand-dark-grey lg:pb-2">
                    {name}
                  </div>
                )}
                {location && (
                  <div className="label-bold pb-3 text-brand-dark-grey lg:pb-4">
                    {location}
                  </div>
                )}
                {description.length > 0 && (
                  <div className="rich_description">
                    <WYSIWYG content={description} />
                  </div>
                )}
                {kspIcon1?.url ||
                kspIcon2?.url ||
                kspIcon3?.url ||
                kspIcon4?.url ||
                kspIcon5?.url ||
                kspIcon6?.url ? (
                  <div className="body-1 pb-3 text-brand-dark-grey lg:pb-4">
                    <div className="flex flex-col gap-2">
                      {kspIcon1 && kspText1 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon1.alt || config.openGraph.images[0].alt}
                            src={kspIcon1.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText1}</div>
                        </div>
                      )}
                      {kspIcon2 && kspText2 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon2.alt || config.openGraph.images[0].alt}
                            src={kspIcon2.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText2}</div>
                        </div>
                      )}
                      {kspIcon3 && kspText3 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon3.alt || config.openGraph.images[0].alt}
                            src={kspIcon3.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText3}</div>
                        </div>
                      )}
                      {kspIcon4 && kspText4 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon4.alt || config.openGraph.images[0].alt}
                            src={kspIcon4.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText4}</div>
                        </div>
                      )}
                      {kspIcon5 && kspText5 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon5.alt || config.openGraph.images[0].alt}
                            src={kspIcon5.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText5}</div>
                        </div>
                      )}
                      {kspIcon6 && kspText6 && (
                        <div className="flex items-center gap-2">
                          <Image
                            alt={kspIcon6.alt || config.openGraph.images[0].alt}
                            src={kspIcon6.url}
                            width={18}
                            height={18}
                          />
                          <div>{kspText6}</div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {addressLine1 && (
                  <div className="body-1 text-brand-dark-grey">
                    {addressLine1}
                  </div>
                )}
                {addressLine2 && (
                  <div className="body-1 pb-3 text-brand-dark-grey lg:pb-4">
                    {addressLine2}
                  </div>
                )}
                <div className="rich_link w-full overflow-scroll scrollbar-hide">
                  <WYSIWYG content={linkField} />
                </div>
              </div>
            </div>
          )
        })}
        <style jsx>
          {`
            .stockistContainer {
              display: grid;
              -ms-overflow-style: none;
              scrollbar-width: none;
              overflow-x: scroll;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              grid-gap: 32px;
            }
            .stockistContainer::-webkit-scrollbar {
              display: none;
            }
            @media (max-width: 1023px) {
              .stockistContainer {
                --visible-cols: 3;
                --col-gap: 32px;
                --col-hint: 10px;
                --col-size: calc(
                  (100% / var(--visible-cols)) - var(--col-gap) -
                    var(--col-hint)
                );
                grid-auto-flow: column;
                grid-template-columns: var(--col-size);
                grid-auto-columns: var(--col-size);
                grid-gap: 32px;
              }
            }
            @media (max-width: 767px) {
              .stockistContainer {
                --visible-cols: 2;
                --col-gap: 32px;
                --col-hint: 20px;
                --col-size: calc(
                  (100% / var(--visible-cols)) - var(--col-gap) -
                    var(--col-hint)
                );
                grid-auto-flow: column;
                grid-template-columns: var(--col-size);
                grid-auto-columns: var(--col-size);
                grid-gap: 32px;
              }
            }
            @media (max-width: 480px) {
              .stockistContainer {
                --visible-cols: 1;
                --col-gap: 32px;
                --col-hint: 100px;
                --col-size: calc(
                  (100% / var(--visible-cols)) - var(--col-gap) -
                    var(--col-hint)
                );
                grid-auto-flow: column;
                grid-template-columns: var(--col-size);
                grid-auto-columns: var(--col-size);
                grid-gap: 24px;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .rich_link .wysiwyg a{
              word-break: break-all;
              white-space: normal;
          }
            .rich_description .wysiwyg p {
              padding-bottom: 12px;
              font-family: Roboto, Arial, sans-serif;
              font-weight: 300;
              font-size: 16px;
              line-height: 24px;
            }
            .rich_description .wysiwyg p:last-child {
              padding-bottom: 16px;
            }
            @media (max-width: 1024px) {
              .rich_description .wysiwyg p:last-child {
                padding-bottom: 12px;
              }
          `}
        </style>
      </div>
    </div>
  )
}

export default Stockists
